import React from 'react';
import './BotaoAndamentoPedido.css';
import { darAndamentoAoPedido } from '../../services/api';

/* eslint-disable no-restricted-globals */

const BotaoAndamentoPedido = ({ idPedido, idProdutoEstabelecimento}) => {

      // Pega os dados da sessão diretamente
      const userData = JSON.parse(sessionStorage.getItem('userData')); // Assume que os dados estão armazenados no sessionStorage


    // const handleButtonClick = async () => {
    const handleButtonClick = async () => {

        console.log('!! Entrou em handleButtonClick !!!');
        console.log('id pedido:');
        console.log(idPedido);
        console.log('id produto estabelecimento:');
        console.log(idProdutoEstabelecimento);
        console.log('userData: ');
        console.log(userData);

        if (confirm("Você tem certeza que deseja dar andamento ao pedido?")) {
            try {
                const resposta = await darAndamentoAoPedido(userData, idPedido, idProdutoEstabelecimento); // Chame a API aqui
                console.log(resposta);
            } catch (error) {
                console.error(error);
            }
        }
    }

    return (
        <button className="dar-andamento-btn" onClick={handleButtonClick}>
            Dar andamento
        </button>
    );
};

export default BotaoAndamentoPedido;
